import { Box, Typography, useTheme } from '@material-ui/core'
import React from 'react'

export const MainTitle = ({ title, rightActions = [] }) => {
	const theme = useTheme()

	return (
		<Box
			display="flex"
			justifyContent="space-between"
			width="100%"
			marginBottom={theme.spacing(0.5)}
			// style={{ backgroundColor: 'red' }}
			alignItems="center">
			<Typography variant="h5" style={{ fontSize: 22, color: '#270050' }}>
				{title}
			</Typography>
			{rightActions.map((action) => action)}
		</Box>
	)
}
